import type React from "react";
import { EllipsisDropdownItem, ChipDownContainer } from "@similarweb/ui-components";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { EBrandedNonBrandedValues } from "app/pages/website-analysis/traffic-sources/search/components/WebsiteKeywordsPageTypes";
import { useWebsiteKeywordsPageTableTopContext } from "app/pages/website-analysis/traffic-sources/search/components/WebsiteKeywordsPageContext";
import { useRankingDistributionTableTopContext } from "app/pages/keyword-research/website-analysis/pages/ranking-distribution/useRankingDistributionTableTopContext";
import { allTrackers } from "app/services/track/track";

const items = [
    {
        text: "analysis.source.search.keywords.filters.branded.default",
        key: "RESET",
    },
    {
        text: "analysis.source.search.keywords.filters.branded.abtest",
        tooltip: "analysis.source.search.keywords.filters.branded.tooltip",
        key: EBrandedNonBrandedValues.IncludeBranded,
    },
    {
        text: "analysis.source.search.keywords.filters.non-branded.abtest",
        tooltip: "analysis.source.search.keywords.filters.non-branded.tooltip",
        key: EBrandedNonBrandedValues.IncludeNoneBranded,
    },
];
// This is the representational component
export const BrandedNonBrandedFilter: React.FC<{
    tableFilters;
    onBrandedNonBrandedChange: (type) => void;
    tooltipText?: string;
}> = ({ tableFilters, onBrandedNonBrandedChange, tooltipText }) => {
    const { IncludeBranded, IncludeNoneBranded } = tableFilters;
    const translate = useTranslation();
    const onToggle = (isOpen) => {
        if (isOpen) {
            allTrackers.dispatchTrackEvent("Drop Down", "open", "Open Branded/NonBranded filter");
        }
    };
    const selected = IncludeBranded
        ? EBrandedNonBrandedValues.IncludeBranded
        : IncludeNoneBranded
          ? EBrandedNonBrandedValues.IncludeNoneBranded
          : null;
    const selectedItem = items.find((item) => item.key === selected);
    return (
        <ChipDownContainer
            width={220}
            onClick={onBrandedNonBrandedChange}
            onToggle={onToggle}
            tooltipText={tooltipText}
            tooltipDisabled={!tooltipText}
            selectedText={selectedItem && translate(selectedItem.text)}
            onCloseItem={() => onBrandedNonBrandedChange(null)}
            buttonText={translate(items[0].text)}
            noResultsMessage={translate("dropdown.no.results")}
        >
            {items.map((item, index) => {
                return (
                    <EllipsisDropdownItem
                        selected={selected === item.key}
                        // @ts-expect-error Type number is not assignable to type string
                        id={item.key}
                        key={index}
                        tooltipText={translate(item.tooltip)}
                    >
                        {translate(item.text)}
                    </EllipsisDropdownItem>
                );
            })}
        </ChipDownContainer>
    );
};

// This are the "connectors" that connect the certain context to the representational component
export const BrandedNonBrandedFilterForWebsiteKeywords = () => {
    const { tableFilters, onBrandedNonBrandedChange } = useWebsiteKeywordsPageTableTopContext();
    return (
        <BrandedNonBrandedFilter
            tableFilters={tableFilters}
            onBrandedNonBrandedChange={onBrandedNonBrandedChange}
        />
    );
};

export const BrandedNonBrandedFilterForRankingDistribution = () => {
    const { tableFilters, onBrandedNonBrandedChange } = useRankingDistributionTableTopContext();
    return (
        <BrandedNonBrandedFilter
            tableFilters={tableFilters}
            onBrandedNonBrandedChange={onBrandedNonBrandedChange}
        />
    );
};
